import React from 'react';
import { ShieldCheck, Lock, Scale, Globe, Award, FileCheck } from 'lucide-react';

const TrustBadgesSection = () => {
  const badges = [
    {
      icon: ShieldCheck,
      title: 'LGPD',
      subtitle: 'Dados Protegidos'
    },
    {
      icon: Scale,
      title: 'CDC',
      subtitle: 'Código de Defesa do Consumidor'
    },
    {
      icon: Lock,
      title: 'Sigilo',
      subtitle: 'Profissional Garantido'
    },
    {
      icon: Globe,
      title: 'Nacional',
      subtitle: 'Atendemos Todo Brasil'
    },
    {
      icon: Award,
      title: '+7 Anos',
      subtitle: 'de Experiência'
    },
    {
      icon: FileCheck,
      title: 'Perícia',
      subtitle: 'Técnica Especializada'
    }
  ];

  return (
    <section className="py-12 bg-slate-900 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <p className="text-center text-slate-500 text-sm font-medium uppercase tracking-wider mb-8">
          Sua segurança é nossa prioridade
        </p>
        
        {/* Badges Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {badges.map((badge, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center group"
            >
              <div className="w-16 h-16 bg-slate-800 border border-slate-700 rounded-2xl flex items-center justify-center mb-3 group-hover:border-emerald-500/50 group-hover:bg-slate-800/80 transition-all duration-300">
                <badge.icon className="w-8 h-8 text-emerald-400" />
              </div>
              <h4 className="text-white font-bold text-sm">{badge.title}</h4>
              <p className="text-slate-500 text-xs">{badge.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadgesSection;
